import { AssetSortType, UrlHelper } from "@nf/common";
import { useCallback } from "react";
import { useTranslation } from "next-i18next";

import Dropdown from "components/Dropdown";
import { NavigateOptions, useRouter } from "hooks";

interface SortingDropdownProps {
  navigateOptions?: NavigateOptions;
}

export const SortingDropdown = ({ navigateOptions }: SortingDropdownProps) => {
  const { t } = useTranslation("translations");
  const router = useRouter();

  const options = [
    { label: t("web_sort_option_popular"), value: AssetSortType.Popular },
    {
      label: t("web_sort_option_recently_added"),
      value: AssetSortType.RecentlyAdded,
    },
    {
      label: t("web_sort_option_alphabetical"),
      value: AssetSortType.Alphabetical,
    },
    { label: t("web_sort_option_year_newest"), value: AssetSortType.Newest },
    { label: t("web_sort_option_year_oldest"), value: AssetSortType.Oldest },
  ];

  const onSortChange = useCallback(
    (sortId?: string) => {
      router.push(
        {
          search: UrlHelper.joinQueries(router.query, {
            sort: sortId,
          }),
        },
        undefined,
        navigateOptions
      );
    },
    [router]
  );

  return (
    <Dropdown
      aria-label={t("web_select_sort")}
      prefix={t("web_select_sort")}
      value={router.query?.sort || AssetSortType.Popular}
      options={options}
      onChange={onSortChange}
    />
  );
};

export default SortingDropdown;
